import { createContext } from "react";

const DistrictContext = createContext();

export default DistrictContext;
